import {
  faqPath,
  aboutUsPath,
  carHirePath,
  generatePath,
  vehiclesPath,
  contactUsPath,
  termsOfUsePath,
  // travelBlogPath,
  cookiePolicyPath,
  oneWayRentalsPath,
  privacyPolicyPath,
  viewModifyCancelPath,
  carRentalLocationsPath,
  termsAndConditionsPath,
  yerevanSlug,
  yerevanAirportSlug,
  internationalLocationsPath,
} from '@/utils'
import { DepthKeys } from '@/hooks'
import { INavItem } from '@/types'

// @ts-ignore
export const footerItems: INavItem<DepthKeys>[] = [
  {
    title: 'sitePolicy',
    subPaths: [
      {
        path: privacyPolicyPath,
        title: 'privacyPolicy',
      },
      {
        path: cookiePolicyPath,
        title: 'cookiePolicy',
      },
      {
        path: termsOfUsePath,
        title: 'termsOfUse',
      },
    ],
  },
  {
    title: 'customerSupport',
    subPaths: [
      {
        path: aboutUsPath,
        title: 'aboutUs',
      },
      {
        path: contactUsPath,
        title: 'contactUs',
      },
      {
        path: faqPath,
        title: 'faq',
      },
      // {
      //   path: travelBlogPath,
      //   title: 'travelBlogAndNews',
      // },
      {
        path: termsAndConditionsPath,
        title: 'rentalTermsAndConditions',
      },
    ],
  },
  {
    title: 'vehicles',
    subPaths: [
      {
        title: 'cars',
        path: generatePath(vehiclesPath, undefined, [{ class: 'cars' }]),
      },
      {
        title: 'suvS',
        path: generatePath(vehiclesPath, undefined, [{ class: 'suvs' }]),
      },
      {
        title: 'vans',
        path: generatePath(vehiclesPath, undefined, [{ class: 'vans' }]),
      },
    ],
  },
  {
    title: 'locations',
    subPaths: [
      {
        title: 'zvartnotsAirport',
        path: generatePath(carRentalLocationsPath, {}, [
          { location: yerevanAirportSlug },
        ]),
      },
      {
        title: 'yerevanDowntown',
        path: generatePath(carRentalLocationsPath, {}, [
          { location: yerevanSlug },
        ]),
      },
      {
        isExternal: true,
        path: internationalLocationsPath,
        title: 'allInternationalLocations',
      },
    ],
  },
  {
    title: 'reservations',
    subPaths: [
      {
        path: carHirePath,
        title: 'startAReservation',
      },
      {
        path: viewModifyCancelPath,
        title: 'viewModifyCancel',
      },
      {
        path: oneWayRentalsPath,
        title: 'oneWayRentals',
      },
    ],
  },
].reverse()
